<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
   <circle fill="currentColor" cx="12" cy="6" r="2"></circle>
   <circle fill="currentColor" cx="12" cy="12" r="2"></circle>
   <circle fill="currentColor" cx="12" cy="18" r="2"></circle>
</svg>
